'use client';
import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';

const testimonials = [
  {
    id: 'testi-arjun',
    name: 'A**** M*****',
    role: 'Student, Grade 10',
    school: 'DPS Noida, India',
    text: 'The Computing & AI olympiad gave me a clear picture of where I stand globally. The AI insights in the report card were incredibly specific — I knew exactly which topics to focus on. My school rank moved from #12 to #3 after two attempts.',
    rating: 5,
    type: 'student',
    rank: 'Global Rank #1,204',
  },
  {
    id: 'testi-priya',
    name: 'Priya Krishnamurthy',
    role: 'Student, Grade 8',
    school: 'Kendriya Vidyalaya, Chennai',
    text: 'I was nervous about an international exam, but the flexible scheduling meant I could take it on a Sunday morning when I was most prepared. The certificate looks genuinely impressive — not like those cheap PDF ones.',
    rating: 5,
    type: 'student',
    rank: 'Percentile 94.2',
  },
  {
    id: 'testi-parent',
    name: 'Dr. Sunita Sharma',
    role: 'Parent',
    school: 'Bengaluru, India',
    text: "As a parent, I wanted something that would challenge my daughter beyond school exams. OnlineOlympiads' report card gave me more actionable data than her school report ever has. I can see exactly where she needs guidance.",
    rating: 5,
    type: 'parent',
    rank: 'Parent of 2 participants',
  },
  {
    id: 'testi-school',
    name: 'Mr. Rajesh Venkataraman',
    role: 'STEM Coordinator',
    school: 'Amrita Vidyalayam, Hyderabad',
    text: "We enrolled 280 students across 4 olympiads. The school dashboard made tracking participation effortless. Our school's aggregate performance report helped us identify curriculum gaps we weren't even aware of.",
    rating: 5,
    type: 'school',
    rank: '280 Students Enrolled',
  },
  {
    id: 'testi-lena',
    name: 'Lena Müller',
    role: 'Student, Grade 11',
    school: 'Gymnasium Heidelberg, Germany',
    text: "Taking an international olympiad from home was something I never thought possible. The exam interface was clean and distraction-free. Getting a global rank alongside students from India, Singapore, and Nigeria was humbling and exciting.",
    rating: 5,
    type: 'student',
    rank: 'Global Rank #892',
  },
];

const typeColors: Record<string, string> = {
  student: 'bg-blue-50 text-blue-700',
  parent: 'bg-purple-50 text-purple-700',
  school: 'bg-green-50 text-green-700',
};

export default function Testimonials() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-24 bg-background">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-secondary bg-secondary/10 rounded-full mb-3 tracking-wide uppercase">
            Testimonials
          </span>
          <h2 className="text-3xl xl:text-4xl font-extrabold text-foreground mb-4">
            Trusted by Students, Parents &amp; Schools
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-card border border-border rounded-3xl p-8 md:p-10 shadow-card relative">
            <div className="flex items-center justify-between mb-6">
              <span className={`px-2.5 py-1 text-xs font-semibold rounded-full ${typeColors[testimonials[active].type]}`}>
                {testimonials[active].type.charAt(0).toUpperCase() + testimonials[active].type.slice(1)}
              </span>
              <div className="flex gap-0.5">
                {Array.from({ length: testimonials[active].rating }).map((_, i) => (
                  <Star key={`star-${active}-${i}`} size={14} className="text-accent fill-accent" />
                ))}
              </div>
            </div>

            <blockquote className="text-lg text-foreground leading-relaxed mb-6 relative z-10">
              &ldquo;{testimonials[active].text}&rdquo;
            </blockquote>

            <div className="flex items-center justify-between">
              <div>
                <p className="font-bold text-foreground">{testimonials[active].name}</p>
                <p className="text-sm text-muted-foreground">{testimonials[active].role}</p>
                <p className="text-xs text-muted-foreground">{testimonials[active].school}</p>
              </div>
              <span className="px-3 py-1 text-xs font-mono font-semibold bg-muted text-muted-foreground rounded-full">
                {testimonials[active].rank}
              </span>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-6">
            <button
              onClick={() => setActive((p) => (p - 1 + testimonials.length) % testimonials.length)}
              className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-muted transition-colors"
              aria-label="Previous testimonial"
            >
              <ChevronLeft size={16} />
            </button>
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={`dot-${i}`}
                  onClick={() => setActive(i)}
                  className={`w-2 h-2 rounded-full transition-all duration-200 ${i === active ? 'bg-primary w-6' : 'bg-border'}`}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
            <button
              onClick={() => setActive((p) => (p + 1) % testimonials.length)}
              className="w-9 h-9 rounded-full border border-border flex items-center justify-center hover:bg-muted transition-colors"
              aria-label="Next testimonial"
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}